import { NJInlineMessage } from '@engie-group/fluid-design-system-react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import type { PrototypeMeta } from '@shared/discoverPrototypes';
import { NetworkShell, PRODUCTION_REF_TABS, Size2MixTabs, TEST_PUC_NETWORK, useSize2MixRefNavigation, type ProductionRefTabId } from '@shared/size2mix-shell';
import { useSynthesis } from './hooks';
import SynthesisTab from './SynthesisTab';

export const meta: PrototypeMeta = {
    title: 'Référence — Production › Synthèse',
    description: "Synthèse de production du réseau test PUC : production, contrats de combustible, mix énergétique, pompes de distribution et stockages thermiques.",
    tags: ['production', 'list', 'reference'],
    author: 'dv5886',
    status: 'reference',
    category: 'production/synthesis',
    createdAt: '2026-10-20',
};

export default function RefProductionSynthesis() {
    const nav = useSize2MixRefNavigation();
    const synthesis = useSynthesis();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="production" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<ProductionRefTabId> tabs={PRODUCTION_REF_TABS} activeId="synthesis" onChange={(id) => nav.goTo(PRODUCTION_REF_TABS.find((tab) => tab.id === id)!.target)} />
                <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    {synthesis.isError ? <NJInlineMessage variant="error" title="Chargement impossible">{synthesis.error.message}</NJInlineMessage>
                        : synthesis.data ? <SynthesisTab data={synthesis.data} /> : <Loading text="Chargement de la synthèse" scale="md" />}
                </div>
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
